import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import Proekt1 from '../Images/kako.PNG'
import Proekt2 from '../Images/ttelo.png'
import Proekt3 from '../Images/Bez-nazwy-2.png'
import Proekt4 from '../Images/Am-I-Responsive-1-5-e1546708591671.jpg'
// local images
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
// global swiper js style
import '../Styles/Carousel.css'
// local swiper js style
// import required modules
import  Qorabuloq from '../Images/qorabuloq — копия.png'
import  Adara from '../Images/adara.png'
import { EffectCoverflow, Pagination } from "swiper";

export default function Carousel() {
  return (
    <>
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={true}
        modules={[EffectCoverflow, Pagination]}
        className="mySwiper"
      >
        <SwiperSlide>
          <div className="carousel-container">
            <img src={Adara} />
            <div className="info-project">
              <h1 className="title-project">Portfolio Web site</h1>
              <h2 className="project-lang"><ion-icon name="settings-outline"></ion-icon>  React js</h2>
              <div className="previev">
                <div className="see-code">viev code <i className="fa-solid fa-right-long"></i></div>
                <button className="see-project">Live Previev</button>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className="carousel-container">
            <img src={Qorabuloq} />
            <div className="info-project">
              <h1 className="title-project">Portfolio Web site</h1>
              <h2 className="project-lang"><ion-icon name="settings-outline"></ion-icon>  React js</h2>
              <div className="previev">
                <div className="see-code">viev code <i className="fa-solid fa-right-long"></i></div>
                <button className="see-project">Live Previev</button>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <img src={Proekt3} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Proekt4} />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-5.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-6.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-7.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-8.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-9.jpg" />
        </SwiperSlide>
      </Swiper>
    </>
  );
}
